export default "__VITE_ASSET__jAXWffKo__"